const _getWindowWidth = () =>
    window.innerWidth ||
    document.body.clientWidth ||
    document.documentElement.clientWidth;

export const isLargeScreen = () => {
    const lg = 996;
    return _getWindowWidth() >= lg;
};

export const isMediumScreen = () => {
    const md = 768;
    return _getWindowWidth() >= md;
};

export const isMobileScreen = () => {
    const md = 768;
    return _getWindowWidth() < md;
};
